// For full API documentation, including code examples, visit https://wix.to/94BuAAs

import winLocation from 'wix-location';
import {memory} from 'wix-storage';
let hovercolor = memory.getItem("HoverColor");




$w.onReady(function () {	

	if(wixWindow.formFactor === "Mobile"){
        $w("#image50").hide();
  	$w("#image49").show();
	}

	

	   

})





export function text33_mouseIn(event,$w) {
	// Add your code for this event here: 
	$w("#text33").html = '<h1 class="font_0" style="color: ' + hovercolor + ' "><span style="letter-spacing:0.05em;"><span style="text-decoration:underline;"> ' + $w("#text33").text + '</span></span></h1>';

}



export function text33_mouseOut(event,$w) {
	// Add your code for this event here: 
	$w("#text33").html = `<h1 class="font_0"><span style="text-decoration:underline;letter-spacing:0.05em;">${$w("#text33").text}</span></span></h1>`;
}


/*import {timeline} from 'wix-animations'
 

$w.onReady(function () {

 const target1 = $w('#image33');

    $w('#image33').onMouseIn(() => {

    timeline()
        .add(target1, {y: 0, x: 0, scale: 0.98, duration: 500, easing: 'easeOutCirc'})
        .play()
})

$w('#image33').onMouseOut(() => {

 const reset = {y: 0, x: 0, scale: 1, duration: 600, easing: 'easeOutCirc'};

    timeline()
        .add(target1, reset)
        .play()
})


});*/